import React from "react";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import ProjectsList from "../components/projects/ProjectsList";
import TechList from "../components/skills/TechList";

const HomePage = ({ theme }) => {
  return (
    <div style={{ overflow: "hidden" }}>
      <Hero theme={theme} />
      <TechList />
      <ProjectsList />
      <Footer />
    </div>
  );
};

export default HomePage;
